// Validation schema
import * as yup from 'yup'
import { ParticipantScope } from '../types'

const validationSchema = yup
    .object({
        title: yup
            .string()
            .required('Tiêu đề không được để trống')
            .min(3, 'Tiêu đề phải có ít nhất 3 ký tự')
            .max(200, 'Tiêu đề không được vượt quá 200 ký tự'),
        start_date: yup
            .string()
            .required('Ngày không được để trống')
            .test(
                'not-past',
                'Không thể tạo sự kiện trong quá khứ',
                function (value) {
                    if (!value) return true
                    const selectedDate = new Date(value)
                    const today = new Date()
                    today.setHours(0, 0, 0, 0)
                    return selectedDate >= today
                }
            ),
        start_time: yup
            .string()
            .required('Giờ bắt đầu không được để trống')
            .matches(
                /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/,
                'Giờ bắt đầu không hợp lệ'
            ),
        duration_minutes: yup
            .number()
            .required('Thời lượng không được để trống'),
        participant_scope: yup
            .string()
            .oneOf(
                ['all', 'department', 'team'],
                'Mức độ hiển thị không hợp lệ'
            )
            .required(
                'Mức độ hiển thị không được để trống'
            ) as yup.StringSchema<ParticipantScope>,
        // room name required if room enabled is true
        // room_name: yup.string().when('room_enabled', {
        //     is: (value: boolean) => value === true || value === false,
        //     then: yup.string().required('Tên phòng không được để trống'),
        //     otherwise: yup.string().notRequired(),
        // }),
    })
    .required()

export default validationSchema
